export const ModuleTypes = {
  ROOT: "root",
  TOP_NAV: "topNav",
  SNACKBAR: "snackbar",
  AUTH: "auth",
  STORAGE: "storage",
  ACADEMY_NAVIGATOR: "academyNavigator",
  STORAGE_ITEM_DETAILS: "storageItemDetails",
  ASSIGNMENTS: "assignments",
  SUBSCRIPTION_SIGNUP: "SubscriptionSignup",
  CREATE_REGISTRATION: "createRegistration",
  TEAM_REGISTRATION: "teamRegistration",
  EVENT_REGISTRATION: "eventRegistration",
  PLAYER_REGISTRATION: "playerRegistration",
  PAYMENTS: "payments",
  TODAY: "today",
  TEAM_CALENDAR: "teamCalendar",
  TEAMS: "teams",
  I_FRAME_MODAL: "IFrameModalModule",
  CHAT: "chat"
};
